import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

/**
 * GradientButton component - A styled button with orange gradient background
 * This component is designed to be used for primary actions across the platform
 */
const GradientButton = ({
                          children,
                          startIcon,
                          endIcon,
                          onClick,
                          className = '',
                          disabled = false,
                          type = 'button',
                          ...props
                        }) => {
  return (
      <Button
          variant="contained"
          onClick={onClick}
          disabled={disabled}
          type={type}
          className={`bg-gradient-to-r from-orange-300 to-orange-600 hover:from-orange-400 hover:to-orange-500 text-white py-2 px-4 rounded-lg shadow-md transition-all duration-200 ${className}`}
          disableElevation
          sx={{
            textTransform: 'none',
            '& .MuiButton-startIcon': {
              marginRight: '4px',
            },
            '&:hover': {
              backgroundColor: 'transparent',
            },
            color: 'white !important',
            fontSize: 'inherit',
            lineHeight: '1.2',
          }}
          startIcon={startIcon}
          endIcon={endIcon}
          {...props}
      >
        {children}
      </Button>
  );
};

GradientButton.propTypes = {
  children: PropTypes.node.isRequired,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default GradientButton;
